import {RouteConfig} from 'vue-router';

export const accountRoutes: RouteConfig = {
    path: 'account',
    component: () => import('@/views/private/account/AccountView.vue'),
    children: [
        {
            path: '',
            name: 'account',
            component: () => import('@/views/private/account/edit/AccountEdit.vue'),
        },
    ],
    meta: {},
};
